<!-- 
Expander panel showing the special tuition protection calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelSpecialTuitionProtectionBreakdown)"
    >
      Calculation breakdown: Special tuition protection component
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.SpecialTuitionProtectionComponent"/>
        <v-card-text class="pa-0">
          <our-data-container v-if="!specialTuitionProtectionAmountsOverridden" right fluid>
            <our-data-field label-width="3" label="Special tuition protection percentage">
              {{ levyCollection.specialTuitionProtectionRate | percentage }} 
            </our-data-field>
            <our-data-field label-width="3" :label="totalLoanTypeDescription">
              {{ levyParameters.loanAmountsPaid | currency }}
            </our-data-field>
            <our-data-field label-width="3" label="Total special tuition protection">
              {{ levyCollection.specialTuitionProtectionRate | percentage }} 
              * 
              {{ levyParameters.loanAmountsPaid | currency }} 
              = 
              <span class="title">
                {{ levyCalculation.specialTuitionProtectionComponent | currency }}
              </span>
              <template v-slot:footer>
                <playground-up-down v-if="isLevyEstimator" field="specialTuitionProtectionComponent" small/>
              </template>
            </our-data-field>
          </our-data-container>
          <our-data-container v-else right fluid>
            <our-data-field :label="calculationOverride.specialTuitionProtectionComponentDescription" label-width="3">
              {{ levyCalculation.specialTuitionProtectionComponent | currency }}
            </our-data-field>
          </our-data-container>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";

export default {
  components: { PlaygroundUpDown },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  }
};
</script>
